/* eslint-disable formatjs/no-literal-string-in-jsx */

import { AnimatedSticker } from '~/components/animated-sticker/animated-sticker';
import { VomitSticker } from '~/module/onboarding/assets';

interface EmptyDropsStateProps {
  className?: string;
}

export const EmptyDropsState = ({ className = '' }: EmptyDropsStateProps) => (
  <div className={`flex flex-col items-center justify-center py-16 px-8 text-center ${className}`}>
    <div className="flex flex-col gap-4 items-center max-w-70">
      <div className="w-[160px] h-[160px]">
        <AnimatedSticker autoplay loop src={VomitSticker} />
      </div>
      <h2 className="text-white text-2xl font-bold font-quicksand">There are currently no drops in progress.</h2>
      <p className="font-bold text-size-[16px] text-white/60">
        Check regularly so you don&apos;t miss out the next drop.
      </p>
    </div>
  </div>
);
